import { type ReactNode } from 'react';
import { formatFollowers } from '@/utils/formatters';

export function BarHeader({
  label,
  total,
  goal,
}: {
  label: string;
  total: number;
  goal: number;
}): ReactNode {
  const pct = Math.min((total / goal) * 100, 100);
  return (
    <div className="flex items-baseline justify-between">
      <p className="text-xs font-medium text-text-secondary">{label}</p>
      <p className="text-[11px] text-text-tertiary">
        {formatFollowers(total)} / {formatFollowers(goal)} ({Math.round(pct)}%)
      </p>
    </div>
  );
}
